<script>

// import JobController from '@/jobController.js';

export default {
    methods: {
        startJob(job) {

            this.$snotify.info('Starting Job', {
                timeout: 0
            });

            job.start()
            .then(() => {
                this.$store.state.localDocuments.isDisabled=1;  
                this.$snotify.clear();
                this.$snotify.success('Job is now running');
                this.$eventBus.$emit('job-started');
            })
            .catch((err) => {
                if (err === 'failed') {
                    this.$store.state.localDocuments.isDisabled=0; 
                    this.$snotify.clear();
                    this.$snotify.error('Job failed to start.');                    
                } else if (err === 'aborted') {
                    this.$store.state.localDocuments.isDisabled=0; 
                    this.$snotify.clear();
                    this.$snotify.error('Job started successfully but it immediately stopped. Please check your job configuration.');
                } else if(err.message) {
                    this.$store.state.localDocuments.isDisabled=0; 
                    this.$snotify.clear();
                    if(err.description && err.description !== '')
                    {
                        this.$snotify.error('Job failed to start.', {
                            buttons: [
                                {text: 'View details...', action:()=>this.$eventBus.$emit('show-error-ecm', 'Job failed to start', err.message, err.description), bold: true },
                            ],
                        });
                    }
                    else
                    {
                        this.$store.state.localDocuments.isDisabled=0; 
                        this.$snotify.error(err.message);
                    }
                } else {
                    this.$snotify.clear();
                    this.$snotify.error('An unknown error occurred trying to start the job.');
                }
            });
        },

        stopJob(job) {
            this.$snotify.info('Stopping Job', {
                timeout: 0
            });

            job.stop()
            .then(() => {
                this.$snotify.clear();
                this.$snotify.success('Job Stopped');
                this.$eventBus.$emit('job-stopped');
            })
            .catch((err) => {
                if(err.message) {
                    this.$snotify.clear();
                    if(err.description && err.description !== '')
                    {
                        this.$snotify.error('Job failed to stop.', {
                            buttons: [
                                {text: 'View details...', action:()=>this.$eventBus.$emit('show-error-ecm', 'Job failed to stop', err.message, err.description), bold: true },
                            ],
                        });
                    }
                    else
                    {
                        this.$snotify.error(err.message);
                    }
                } else {
                    this.$snotify.clear();
                    this.$snotify.error('There was an error trying to stop the job.');
                }
            });
        },

        resumeJob(job) {

            this.$snotify.info('Resuming Job', {
                timeout: 0
            });

            job.resume()
            .then(() => {
                this.$snotify.clear();
                this.$snotify.success('Job is now running');
            })
            .catch((err) => {
                if(err.message) {
                    this.$snotify.clear();
                    if(err.description && err.description !== '')
                    {
                        this.$snotify.error('Job failed to resume.', {
                            buttons: [
                                {text: 'View details...', action:()=>this.$eventBus.$emit('show-error-ecm', 'Job failed to resume', err.message, err.description), bold: true },
                            ],
                        });
                    }
                    else
                    {
                        this.$snotify.error(err.message);
                    }
                } else {
                    this.$snotify.clear();
                    this.$snotify.error('An unknown error occurred trying to resume the job.');
                }
            });
        },

        deleteJob(job_id) {
            this.$snotify.info('Deleting Job', {
                timeout: 0
            });

            return this.$store.dispatch('job/deleteJob', {
                job_id
            })
            .then((res) => {
                this.$snotify.clear();
                this.$snotify.success('Job Deleted');
                this.$eventBus.$emit('job-deleted');
                return res;
            })
            .catch((err) => {
                this.$snotify.clear();
                console.error(err);
                this.$snotify.error('Job failed to be deleted.');
                return err;
            });
        },

        cloneJob(job_id) {

        },

        editJob(job_id) {

        }
    }
}

</script>
